module.exports = __webpack_public_path__ + "img/intro.f494ea4d.jpg";